import { styled } from '@ghq-abi/design-system';

import { COLORS, SIZES } from '~/shared/constants/colors';

const baseInputStyles = {
  width: '100%',
  borderRadius: '$sm',
  border: '1px solid #CACDD5',
  backgroundColor: '#FBFAFC',
  fontSize: '$sm',
  color: '$gray800',
  outline: 'none',
  transition: 'all 0.2s ease',

  '&:hover': {
    borderColor: '#325A6D',
    boxShadow: '0 0 0 2px rgba(50, 90, 109, 0.15)',
    backgroundColor: 'white',
  },

  '&:focus': {
    borderColor: '#325A6D',
    boxShadow: '0 0 0 2px rgba(50, 90, 109, 0.25)',
    backgroundColor: 'white',
  },

  '&::placeholder': {
    color: '$gray600',
  },
};

const inputWithIconStyles = {
  ...baseInputStyles,
  padding: '$2 $6 $2 $9',
};

const iconPositionStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
};

const formComponentStyles = {
  width: '100%',
  backgroundColor: '$white',
  borderRadius: '$md',
  overflow: 'hidden',
  marginBottom: '$4',
};

const formHeaderStyles = {
  padding: '$4',
  borderBottom: '1px solid $gray200',
  backgroundColor: '$gray50',
};

const formContentStyles = {
  padding: '$4',
};

const chevronIconStyles = {
  '&::after': {
    content: '""',
    width: '8px',
    height: '8px',
    borderRight: '2px solid #6B7280',
    borderBottom: '2px solid #6B7280',
    transform: 'rotate(45deg)',
  },
};

export const FormComponentContainer = styled('div', formComponentStyles);
export const FormComponentHeader = styled('div', formHeaderStyles);
export const FormComponentTitle = styled('h3', {
  fontSize: '$md',
  fontWeight: '600',
  color: '$gray800',
  margin: '0',
});
export const FormComponentContent = styled('div', formContentStyles);

export const FormInput = styled('input', {
  ...baseInputStyles,
  height: SIZES.INPUT_HEIGHT,
  padding: '$2 $3',
});

export const FormInputWithIcon = styled('input', {
  ...inputWithIconStyles,
  height: SIZES.INPUT_HEIGHT,
});

export const InputWrapper = styled('div', {
  position: 'relative',
  width: '100%',
});

export const InputIcon = styled('div', {
  ...iconPositionStyles,
  left: '$3',
});

export const FormField = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  marginBottom: '$4',
  width: '100%',

  '&:hover label': {
    color: COLORS.TEXT_DARK,
  },
});

export const FieldLabel = styled('label', {
  fontSize: '$sm',
  color: '$gray800',
  display: 'flex',
  alignItems: 'center',
  gap: '$1',

  '& .required': {
    color: COLORS.ERROR,
    marginLeft: '2px',
  },
});
